const state = {
  currentUser: {}
  //signinError: null
};

export default state;
